var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vigilanti" },
    [
      _c(
        "div",
        { staticClass: "layout wrap widgets" },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c("FiltrosBusqueda", {
                attrs: {
                  listaTiposAlerta: _vm.listaTiposAlerta,
                  listaFlotas: _vm.listaFlotas,
                  listaGrupos: _vm.listaGrupos,
                  listaPatentes: _vm.listaPatentes,
                  formFields: _vm.formFields
                },
                on: {
                  resultadoBusqueda: _vm.filtroAlertas,
                  changeFlota: _vm.changeFlota,
                  changeGrupo: _vm.changeGrupo,
                  clear: _vm.AlertaInicial
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticStyle: { "align-self": "end" },
                  attrs: { sm1: "", md1: "" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { "padding-top": "15px" },
                      attrs: { align: "right" }
                    },
                    [
                      _vm.accionExportar.visible
                        ? _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.exportar("csv")
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v("  \n            "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Exportar"), _c("br"), _vm._v("CSV")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-flex",
                {
                  staticStyle: { "align-self": "end" },
                  attrs: { sm1: "", md1: "" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { "padding-top": "15px" },
                      attrs: { align: "right" }
                    },
                    [
                      _vm.accionExportar.visible
                        ? _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.exportar("xlsx")
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v("  \n            "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Exportar"), _c("br"), _vm._v("EXCEL")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-flex",
                {
                  staticStyle: { "align-self": "end" },
                  attrs: { sm1: "", md1: "" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { "padding-top": "15px" },
                      attrs: { align: "right" }
                    },
                    [
                      _vm.accionExportar.visible
                        ? _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.exportar("pdf")
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v("  \n            "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Exportar"), _c("br"), _vm._v("PDF")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("WidgetAlerta", {
        attrs: { listaAlertasWidgets: _vm.listaAlertasWidgets },
        on: { filtroWidget: _vm.filtroWidget }
      }),
      _c(
        "div",
        { staticClass: "gridcard rounded-card camaras" },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                "offset-md10": "",
                "offset-sm10": "",
                sm2: "",
                md2: "",
                hide: ""
              }
            },
            [
              _c("v-text-field", {
                staticStyle: { "margin-right": "5px" },
                attrs: { label: "Buscar..." },
                on: { input: _vm.searchData },
                model: {
                  value: _vm.filtrobusquedagrilla,
                  callback: function($$v) {
                    _vm.filtrobusquedagrilla = $$v
                  },
                  expression: "filtrobusquedagrilla"
                }
              })
            ],
            1
          ),
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleAlertaModal", {
            attrs: { alertaSeleccionado: _vm.alertaSeleccionado },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _vm.showEvidencia
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEvidencia", attrs: { id: "myModal" } },
              [
                _c("div", { staticClass: "modalEvidencia-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "buttonClose",
                      staticStyle: { "padding-top": "15px" },
                      attrs: { align: "right" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.closeImage()
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("close")
                          ]),
                          _vm._v("  \n            "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Cerrar")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "wrap-evidencia-img" }, [
                    _vm.linkEvidencia
                      .split(".")
                      .pop()
                      .toLowerCase() == "mp4"
                      ? _c(
                          "video",
                          {
                            attrs: {
                              width: "100%",
                              controls: "",
                              disablepictureinpicture: "",
                              controlslist: "nodownload noplaybackrate",
                              muted: ""
                            },
                            domProps: { muted: true },
                            on: {
                              load: function($event) {
                                return _vm.imageLoaded()
                              },
                              error: function($event) {
                                return _vm.imageError()
                              },
                              contextmenu: function($event) {
                                return _vm.handlerContexTmenu($event)
                              }
                            }
                          },
                          [
                            _c("source", {
                              attrs: {
                                src: _vm.linkEvidencia,
                                type: "video/mp4"
                              }
                            }),
                            _vm._v(
                              "\n            Your browser does not support the video tag.\n          "
                            )
                          ]
                        )
                      : _c("img", {
                          attrs: { src: _vm.linkEvidencia },
                          on: {
                            load: function($event) {
                              return _vm.imageLoaded()
                            },
                            error: function($event) {
                              return _vm.imageError()
                            }
                          }
                        })
                  ])
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.showEnviarCorreo
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeEnvio()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", md12: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Correo",
                              "single-line": "",
                              type: "email"
                            },
                            on: { blur: _vm.validateEmail },
                            model: {
                              value: _vm.correoEvidencia,
                              callback: function($$v) {
                                _vm.correoEvidencia = $$v
                              },
                              expression: "correoEvidencia"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-style": "italic",
                                margin: "0 auto",
                                "font-size": "12px"
                              }
                            },
                            [
                              _vm._v(
                                "Puede ingresar varios correos separados por punto y coma\n              (;)"
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticStyle: { "margin-top": "20px" },
                                attrs: { flat: "", icon: "", small: "" },
                                on: { click: _vm.handleEnviarCorreoClick }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { staticClass: "importExportBtnIcon" },
                                  [_vm._v("send")]
                                ),
                                _vm._v(
                                  "  \n                Enviar\n              "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(1),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/informe-generado-vigilanti"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Evidencia por Correo")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }